// AWS Amplify configuration for Cognito authentication
export const amplifyConfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_AWS_REGION || 'us-east-2',
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
      loginWith: {
        email: true,
      },
    }
  },
  API: {
    REST: {
      healthAPI: {
        endpoint: process.env.REACT_APP_API_ENDPOINT || '',
        region: process.env.REACT_APP_AWS_REGION || 'us-east-2',
      }
    }
  }
};

export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3001',
  endpoints: {
    events: '/events',
    trace: '/traces',
    stats: '/stats',
    analyzeEvent: '/analyze-event',
    dailySummary: '/daily-summary',
    chat: '/chat',
    operationalData: '/operational-data',
    knowledge: '/knowledge',
    research: '/research',
    userContext: '/user-context',
  }
};
